document.addEventListener('DOMContentLoaded', function () {
  var containers = document.querySelectorAll('.product__description');

  containers.forEach(function (container, containerIndex) {
    var h3s = container.querySelectorAll('h3');
    if (!h3s.length) return; // no H3s, leave description untouched

    var sections = [];
    var current = null;

    Array.from(container.childNodes).forEach(function (node) {
      if (node.nodeType === 1 && node.tagName === 'H3') {
        current = { heading: node.textContent.trim(), content: [] };
        sections.push(current);
      } else if (current) {
        current.content.push(node);
      }
    });

    if (!sections.length) return;

    var wrapper = document.createElement('div');
    wrapper.className = 'description-accordion';

    sections.forEach(function (section, i) {
      var uid = 'DescAccordion-' + containerIndex + '-' + i;

      var accordion = document.createElement('div');
      accordion.className = 'accordion';

      var details = document.createElement('details');
      details.id = 'Details-' + uid;

      var summary = document.createElement('summary');
      summary.id = 'Summary-' + uid;

      var heading = document.createElement('h3');
      heading.className = 'accordion__title inline-richtext h4';
      heading.textContent = section.heading;
      summary.appendChild(heading);
      summary.insertAdjacentHTML('beforeend', window.__accordionCaretIcon || '');

      var content = document.createElement('div');
      content.className = 'accordion__content rte';
      content.setAttribute('role', 'region');
      content.setAttribute('aria-labelledby', summary.id);
      section.content.forEach(function (n) { content.appendChild(n); });

      details.appendChild(summary);
      details.appendChild(content);
      accordion.appendChild(details);
      wrapper.appendChild(accordion);
    });

    container.innerHTML = '';
    container.appendChild(wrapper);
  });
});